import { inject, provideAppInitializer } from '@angular/core';
import { PosthogService } from '@examdojo/core/posthog';
import { setupConsoleErrorPatching } from '@examdojo/error-handling';
import { AuthService } from '@examdojo/user';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { register as registerSwiper } from 'swiper/element/bundle';
import { LanguageService } from './i18n/language.service';

export const APP_INITIALIZER_PROVIDER = provideAppInitializer(async () => {
  const authService = inject(AuthService);
  const languageService = inject(LanguageService);
  const faIconLibrary = inject(FaIconLibrary);
  const posthogService = inject(PosthogService);

  console.debug('[APP_INITIALIZER]: starting');

  console.debug('[APP_INITIALIZER]: loading user');

  try {
    setupConsoleErrorPatching();

    posthogService.init();
    faIconLibrary.addIconPacks(far);

    await authService.loadUser();

    languageService.loadLanguageFromLocalStorage();

    registerSwiper();
  } catch (err) {
    console.error('[APP_INITIALIZER]: errored', err);
  }

  console.debug('[APP_INITIALIZER]: finished');
});
